import { ShiftsSwapShiftFragment } from 'generated/resources/graphql'

import { Model } from 'modules/core/lib/mobx-rest'

export type StatusType = 'pending' | 'approved' | 'rejected' | 'expired' | 'cancelled'

export interface Props {
  id: string
  status: string
  reason: string
  teammateReason: string
  managerReason: string
}

class SwapShift extends Model<Props> {
  status: string
  reason: string
  teammateReason: string
  managerReason: string

  constructor(props: Props) {
    super(props)

    this.status = props.status
    this.reason = props.reason
    this.teammateReason = props.teammateReason
    this.managerReason = props.managerReason
  }

  static types: Record<StatusType, StatusType> = {
    pending: 'pending',
    approved: 'approved',
    rejected: 'rejected',
    expired: 'expired',
    cancelled: 'cancelled',
  }

  static buildFromRequest(props: ShiftsSwapShiftFragment): SwapShift {
    return new SwapShift({
      id: props.id,
      status: props.status,
      reason: props.reason,
      teammateReason: props.teammateReason,
      managerReason: props.managerReason,
    })
  }
}

export default SwapShift
